import { X } from "lucide-react";
import React from "react";

interface ModalProps {
  children: React.ReactNode;
  title?: string;
  show: boolean;
  showCloseButton?: boolean;
  handleClose: () => void;
  fullScreen?: boolean;
}
const Modal: React.FC<ModalProps> = ({
  children,
  title,
  show = false,
  showCloseButton = false,
  handleClose,
  fullScreen = false,
}) => {
  if (!show) return null;
  return (
    <div
      className="fixed top-0 bottom-0 left-0 right-0 z-50 bg-black/50"
      onClick={handleClose}
    >
      <div
        className={`fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 bg-white overflow-y-hidden max-w-lg mx-auto ${
          fullScreen ? "w-full h-full" : "w-[90%] max-h-[90vh] rounded-xl"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        {title && (
          <div className="flex items-center justify-between border-b border-gray-200 px-4 py-3">
            <h3 className="text-lg font-semibold text-gray-800 flex-1 text-center">
              {title}
            </h3>
          </div>
        )}
        {showCloseButton && (
          <button
            className="z-10 absolute top-2.5 right-3 w-8 h-8 flex items-center justify-center hover:bg-gray-100 rounded-full"
            onClick={handleClose}
          >
            <X className="w-5 h-5 text-gray-500" />
          </button>
        )}
        <div className="p-4 max-h-[calc(100vh-100px)] overflow-y-auto overflow-x-hidden">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
